import { render, staticRenderFns } from "./HouseArea.vue?vue&type=template&id=a64d18f8&"
import script from "./HouseArea.vue?vue&type=script&lang=js&"
export * from "./HouseArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports